import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css';

class SpecTestsExaminationTesting extends React.Component {

    render() {
            let options = [
            { id: '1+', value: '1+' },
            { id: '2+', value: '2+' },
            { id: '3+', value: '3+' },
            { id: '>3+', value: '>3+' },
            { id: 'Neg', value: 'Neg' }
        ];
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_ExaminationTesting' name='Examination Testing' flagged={this.props.flagged}>
                
                     <div className={styles.sij_row}>
                        <div className={styles.flag} />
                        <div className={styles.label} />
                        <div className={styles.r_header}>R</div>
                        <div className={styles.c_header} />
                        <div className={styles.l_header}>L</div>
                     </div>
                       <div key={this.props.panelId} className={styles.dropdown_row}>
                        <span className={styles.flag} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>SIJ Provocation Cluster</label>
                             <DBDropDownObjective 
                            noteId={this.props.noteId} 
                            entity='PTOBJECTIVESPECTESTS' 
                            entityKeyColumn='TSNO' 
                            entityKeyValue={this.props.tsno} 
                            field='TSSIJCLUSTERR' 
                            className={styles.r}
                            customOptions={options} 
                            />
                            <span className={styles.c} />
                               <DBDropDownObjective 
                                noteId={this.props.noteId} 
                                entity='PTOBJECTIVESPECTESTS' 
                                entityKeyColumn='TSNO' 
                                entityKeyValue={this.props.tsno} 
                                field='TSSIJCLUSTERL' 
                                className={styles.l}
                                customOptions={options} 
                    />
                    </div>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Examination Testing' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSIJCLUSTERR === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSIJCLUSTERL === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLUMBARFLEXQUADR === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLUMBARFLEXQUADL === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLUMBAREXTQUADR === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLUMBAREXTQUADL === 1) {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'Examination Testing'),
        flagged: flagCount >= 1 ? true : false
    };
}

const connectedSpecTestsExaminationTesting = connect(mapStateToProps)(SpecTestsExaminationTesting);
export { connectedSpecTestsExaminationTesting as SpecTestsExaminationTesting };



